import axios from 'axios';
import { format } from 'date-fns';

import { ApiResponse } from '../../models/api.response.model';
import { Error } from '../../models/error.model';
import { Invoice } from '../../models/invoice.model';
import { ProviderInvoice } from '../../models/provider.invoice.model';
import { AccountingEntry } from '../../models/accounting.entry.model';
import { authToken } from '../../scripts/authentication.script';

export class PaymentDA {
  static apiResponse: ApiResponse

  public static async postPaymentInvoice(
    id_company: string,
    id_invoice: string,
    amount_pay: string,
    amount_deposit: string,
    date: string,
    method: string,
    treasury_account_id: string,
    accounting_entry_id: string,
    _company_tax: { subject_tax: boolean, tax_method: string, tax_declaration: string, tax_period: string, tax_statement: string, language: string }
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let accountingEntries: AccountingEntry[] | null = null
      let invoice: Invoice | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/accounting.entries.credit.incomplete.data.json').then(response => { accountingEntries = response.data.accounting_entries }).catch(error => { alert(error) })
      await axios.get('../../../../../database/sale.invoice.data.json').then(response => { invoice = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (invoice!.id === id_invoice && invoice!.amount.debt >= Number(amount_pay)) {
        let accountingEntry: AccountingEntry | null = accountingEntries!.find(item => item.id === accounting_entry_id) ?? null

        invoice!.validated = true
        invoice!.amount.debt -= Number(amount_pay)
        invoice!.amount.paid += Number(amount_pay)
        invoice!.payment_status = (invoice!.amount.debt === 0) ? 'fully-paid' : 'partially-paid'
        invoice!.payments.push({
          id: `payment${(Math.floor(Math.random() * 1000)).toString()}`,
          amount: Number(amount_pay),
          source: (accounting_entry_id.length > 0) ? accountingEntry!.debits[0].type === 'treasury-account' ? accountingEntry!.debits[0].reference.id_treasury_account : '' : treasury_account_id,
          method: (accounting_entry_id.length > 0) ? accountingEntry!.debits[0].type === 'credit-note' ? 'credit-note' : '' : method,
          created_date: (accounting_entry_id.length > 0) ? accountingEntry!.date : date,
          created_at: `${format((new Date()), `yyyy-MM-dd'T'HH:mm:ss.SSSXXX`)}`,
          updated_at: `${format((new Date()), `yyyy-MM-dd'T'HH:mm:ss.SSSXXX`)}`,
          is_delete: false
        })

        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: invoice
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/invoices/${id_invoice}/payments`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        amount_pay: Number(amount_pay),
        amount_deposit: Number(amount_deposit),
        created_date: date,
        method: method,
        treasury_account: treasury_account_id,
        accounting_entry: accounting_entry_id,
      }

      await axios.post(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.error
        }
      })
    }

    return this.apiResponse
  }

  public static async postPaymentProviderInvoice(
    id_company: string,
    id_provider_invoice: string,
    amount_pay: string,
    amount_deposit: string,
    date: string,
    method: string,
    treasury_account_id: string,
    accounting_entry_id: string,
    _company_tax: { subject_tax: boolean, tax_method: string, tax_declaration: string, tax_period: string, tax_statement: string, language: string }
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let accountingEntries: AccountingEntry[] | null = null
      let providerInvoice: ProviderInvoice | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/accounting.entries.debit.incomplete.data.json').then(response => { accountingEntries = response.data.accounting_entries }).catch(error => { alert(error) })
      await axios.get('../../../../../database/purchase.invoice.data.json').then(response => { providerInvoice = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (providerInvoice!.id === id_provider_invoice && providerInvoice!.amount.debt >= Number(amount_pay)) {
        let accountingEntry: AccountingEntry | null = accountingEntries!.find(item => item.id === accounting_entry_id) ?? null

        providerInvoice!.validated = true
        providerInvoice!.amount.debt -= Number(amount_pay)
        providerInvoice!.amount.paid += Number(amount_pay)
        providerInvoice!.payment_status = (providerInvoice!.amount.debt === 0) ? 'fully-paid' : 'partially-paid'
        providerInvoice!.payments.push({
          id: `payment${(Math.floor(Math.random() * 1000)).toString()}`,
          amount: Number(amount_pay),
          source: (accounting_entry_id.length > 0) ? accountingEntry!.credits[0].type === 'treasury-account' ? accountingEntry!.credits[0].reference.id_treasury_account : '' : treasury_account_id,
          method: (accounting_entry_id.length > 0) ? accountingEntry!.credits[0].type === 'credit-note' ? 'credit-note' : '' : method,
          created_date: (accounting_entry_id.length > 0) ? accountingEntry!.date : date,
          created_at: `${format((new Date()), `yyyy-MM-dd'T'HH:mm:ss.SSSXXX`)}`,
          updated_at: `${format((new Date()), `yyyy-MM-dd'T'HH:mm:ss.SSSXXX`)}`,
          is_delete: false
        })

        this.apiResponse = {
          status: 201,
          message: 'Success',
          data: providerInvoice
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/provider-invoices/${id_provider_invoice}/payments`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      let data: any = {
        amount_pay: Number(amount_pay),
        amount_deposit: Number(amount_deposit),
        created_date: date,
        method: method,
        treasury_account: treasury_account_id,
        accounting_entry: accounting_entry_id,
      }

      await axios.post(url, data, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.error
        }
      })
    }

    return this.apiResponse
  }

  public static async deletePaymentInvoice(
    id_company: string,
    id_invoice: string,
    id_payment: string,
    _company_tax: { subject_tax: boolean, tax_method: string, tax_declaration: string, tax_period: string, tax_statement: string, language: string }
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let invoice: Invoice | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/sale.invoice.data.json').then(response => { invoice = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (invoice!.payments.some(item => item.id === id_payment)) {
        invoice!.amount.debt += Number(invoice!.payments.find(item => item.id === id_payment)!.amount)
        invoice!.amount.paid -= Number(invoice!.payments.find(item => item.id === id_payment)!.amount)
        invoice!.payment_status = (invoice!.amount.paid === 0) ? 'not-payed' : 'partially-paid'
        invoice!.payments = invoice!.payments.filter(item => item.id !== id_payment)

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: invoice
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/invoices/${id_invoice}/payments/${id_payment}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.delete(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.error
        }
      })
    }

    return this.apiResponse
  }

  public static async deletePaymentProviderInvoice(
    id_company: string,
    id_provider_invoice: string,
    id_payment: string,
    _company_tax: { subject_tax: boolean, tax_method: string, tax_declaration: string, tax_period: string, tax_statement: string, language: string }
  ): Promise<ApiResponse> {
    if (process.env.REACT_APP_ENVIRONMENT === 'development') {
      let providerInvoice: ProviderInvoice | null = null
      let error: Error | null = null

      await axios.get('../../../../../database/sale.invoice.data.json').then(response => { providerInvoice = response.data }).catch(error => { alert(error) })
      await axios.get('../../../../../database/error.data.json').then(response => { error = response.data }).catch(error => { alert(error) })

      if (providerInvoice!.payments.some(item => item.id === id_payment)) {
        providerInvoice!.amount.debt += Number(providerInvoice!.payments.find(item => item.id === id_payment)!.amount)
        providerInvoice!.amount.paid -= Number(providerInvoice!.payments.find(item => item.id === id_payment)!.amount)
        providerInvoice!.payment_status = (providerInvoice!.amount.paid === 0) ? 'not-payed' : 'partially-paid'
        providerInvoice!.payments = providerInvoice!.payments.filter(item => item.id !== id_payment)

        this.apiResponse = {
          status: 200,
          message: 'Success',
          data: providerInvoice
        }
      } else {
        this.apiResponse = {
          status: 400,
          message: 'Bad request',
          data: error
        }
      }
    } else {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/provider-invoices/${id_provider_invoice}/payments/${id_payment}`

      let config: any = {
        headers: { Authorization: authToken() }
      }

      await axios.delete(url, config).then(response => {
        this.apiResponse = {
          status: response.status,
          message: response.statusText,
          data: response.data?.data ?? response.data
        }
      }).catch(error => {
        this.apiResponse = {
          status: error.response.status,
          message: error.response.statusText,
          data: error.response.data.error
        }
      })
    }

    return this.apiResponse
  }
}
